import React from "react";
import { NumericFormat } from "react-number-format";
import { highlightAll, twoDecimal } from "../../utils";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";

export const LineItem = ({ label, onChange, value, readOnly, adornment, endAdornment, align }) => {

	if(label === "expense") {
		if(!!readOnly && value === "NET RATE") {
			return (
				<Typography variant="body2" sx={{
					pl: .5, pr: 1.75, py: 1,
					fontSize: ".8rem",
					textAlign: "end",
					height: "100%",
					display: "flex",
					justifyContent: "end",
					alignItems: "center"
				}}>
					<b>{value}</b>
				</Typography>
			);
		}else {
			return (
				<TextField
					variant="outlined"
					size="small"
					{...{value}}
					onChange={(e) => onChange(e, label)}
					placeholder="Type your line title here..."
					fullWidth
					inputProps={{readOnly, onFocus: !readOnly && highlightAll}}
				/>
			);
		}
	}else {
		return (
			<Box sx={{
				height: "100%",
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
				pr: !!readOnly ? "14px !important" : "0 !important",
				border: "unset !important",
				"& span": {
					height: "100%",
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-end"
				}
			}}>
				<NumericFormat
					prefix={(!!readOnly && adornment === "$") ? "$ " : ""}
					displayType={!!readOnly ? "text" : "input"}
					fixedDecimalScale
					allowLeadingZeros
					thousandSeparator=","
					decimalScale={!!(adornment || endAdornment) ? 2 : 0}
					customInput={TextField}
					sx={{"& input": {textAlign: align || "end"}}}
					variant="outlined"
					size="small"
					value={twoDecimal(value)}
					onChange={(e) => onChange(e, label)}
					InputProps={{
						startAdornment: !!adornment && <InputAdornment position="start">{adornment}</InputAdornment>,
						endAdornment: !!endAdornment && <InputAdornment position="end">{endAdornment}</InputAdornment>
					}}
					inputProps={{readOnly, onFocus: !readOnly && highlightAll}}
					fullWidth
				/>
			</Box>
		);
	}
};